export const ENDPOINTS = {
  apiVersions: '/autopay_sdk_mobile/versions.json'
}

export const API_REQUEST_STATUS = {
  success: 'SUCCESS',
  fail: 'FAIL'
}
